import { FC } from 'react'

const PauseIcon: FC<{ color?: string }> = ({ color = 'orange' }) => {
  return (
    <svg className={'w-[18px] h-[18px]'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        fill={color}
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0l0 128c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-128c0-17.7 14.3-32 32-32s32 14.3 32 32z"
      />
    </svg>
  )
}

export default PauseIcon
